<template>
  <div class="qr-funnel">
    <div class="qr-funnel__header">
      <h3 class="qr-funnel__title">Customer Journey</h3>
      <p class="qr-funnel__subtitle">
        Conversion funnel from QR open to completed booking
      </p>
    </div>

    <div class="qr-funnel__body">
      <div
        v-for="(stage, index) in stages"
        :key="stage.name"
        class="qr-funnel__stage"
      >
        <div
          class="qr-funnel__stage-bg"
          :style="stageBgStyle(index, stage.color)"
        />
        <div
          class="qr-funnel__stage-content"
          :style="contentStyle(index)"
        >
          <span class="qr-funnel__stage-label">{{ stage.name }}</span>
          <span class="qr-funnel__stage-value">
            {{ formatValue(stage.value) }}
            <span class="qr-funnel__stage-percent">{{ stage.percent }}%</span>
          </span>
        </div>
      </div>
    </div>

    <div class="qr-funnel__footer">
      <feather-icon icon="CheckCircleIcon" svgClasses="qr-funnel__footer-icon" />
      <span class="qr-funnel__footer-text">
        Revenue
        <strong>{{ revenue }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
const INSET_STEP = 6.5;

export default {
  name: "QrCustomerJourney",
  props: {
    stages: { type: Array, required: true },
    revenue: { type: String, default: "£0" },
  },
  methods: {
    formatValue(value) {
      return Number(value).toLocaleString();
    },
    stageBgStyle(index, color) {
      const topInset = index * INSET_STEP;
      const bottomInset = (index + 1) * INSET_STEP;
      return {
        backgroundColor: color,
        clipPath: `polygon(${topInset}% 0%, ${100 - topInset}% 0%, ${100 - bottomInset}% 100%, ${bottomInset}% 100%)`,
      };
    },
    contentStyle(index) {
      const topInset = index * INSET_STEP;
      const bottomInset = (index + 1) * INSET_STEP;
      const midInset = (topInset + bottomInset) / 2;
      return {
        paddingLeft: `${midInset + 3}%`,
        paddingRight: `${midInset + 3}%`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.qr-funnel {
  background: #fff;
  border-radius: 18px;
  padding: 1.5rem 1.5rem 1.25rem;
  box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);
  border: 1px solid #ececf2;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__header {
    margin-bottom: 1.25rem;
  }

  &__title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #2d2d2d;
    margin: 0 0 0.35rem;
    line-height: 1.3;
  }

  &__subtitle {
    font-size: 0.8125rem;
    color: #a8a8b3;
    margin: 0;
    line-height: 1.4;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    flex: 1;
    padding: 0 1rem;
  }

  &__stage {
    position: relative;
    width: 100%;
    max-width: 380px;
    height: 52px;
    flex-shrink: 0;
  }

  &__stage-bg {
    position: absolute;
    inset: 0;
    border-radius: 1px;
  }

  &__stage-content {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    color: #fff;
    pointer-events: none;
  }

  &__stage-label {
    font-size: 0.9375rem;
    font-weight: 500;
    letter-spacing: -0.01em;
    white-space: nowrap;
  }

  &__stage-value {
    font-size: 0.9375rem;
    font-weight: 700;
    display: inline-flex;
    align-items: baseline;
    gap: 0.45rem;
    white-space: nowrap;
  }

  &__stage-percent {
    font-weight: 600;
    opacity: 0.95;
  }

  &__footer {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    align-self: center;
    margin-top: 1.25rem;
    padding: 0.65rem 1.35rem;
    border-radius: 999px;
    background: #ecfdf5;
    border: 1px solid #bbf7d0;
  }

  &__footer-icon {
    width: 16px;
    height: 16px;
    color: #16a34a;
    flex-shrink: 0;
  }

  &__footer-text {
    font-size: 0.875rem;
    color: #4b5563;
    line-height: 1.3;

    strong {
      margin-left: 0.35rem;
      font-weight: 700;
      color: #16a34a;
    }
  }
}
</style>
